// メールアドレスを分割して定義（スパム対策）
const user = "infom";
const domain = "vision-drive.co.jp";
const email = user + "@" + domain;

// Gmail の作成画面を直接開く URL を生成
const buildGmailUrl = (subject, body) => {
  const params = new URLSearchParams({ view: "cm", fs: "1", to: email });
  if (subject) params.set("su", subject);
  if (body) params.set("body", body);
  return "https://mail.google.com/mail/?" + params.toString();
};

// mailto URL を生成
const buildMailto = (subject, body) => {
  const params = new URLSearchParams();
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  const query = params.toString();
  return "mailto:" + email + (query ? "?" + query : "");
};

// 選択肢モーダルを1つだけ生成して使い回す
let modal = null;
let lastFocused = null;

const closeModal = () => {
  if (!modal) return;
  modal.hidden = true;
  document.body.classList.remove("is-maillink-open");
  if (lastFocused) lastFocused.focus();
};

const createModal = () => {
  modal = document.createElement("div");
  modal.className = "maillink-modal";
  modal.hidden = true;
  modal.innerHTML = `
    <div class="maillink-modal__overlay" data-close></div>
    <div class="maillink-modal__panel" role="dialog" aria-modal="true" aria-label="メールの送信方法を選択">
      <button type="button" class="maillink-modal__close" data-close aria-label="閉じる">&times;</button>
      <p class="maillink-modal__addr">${email}</p>
      <ul class="maillink-modal__list">
        <li><a class="maillink-modal__btn" data-action="mail" href="#">メールアプリで開く</a></li>
        <li><a class="maillink-modal__btn" data-action="gmail" href="#" target="_blank" rel="noopener">Gmailで開く</a></li>
        <li><button type="button" class="maillink-modal__btn" data-action="copy">アドレスをコピー</button></li>
      </ul>
      <p class="maillink-modal__msg" aria-live="polite"></p>
    </div>`;
  document.body.appendChild(modal);

  // 閉じる操作（オーバーレイ・×ボタン）
  modal.addEventListener("click", (e) => {
    if (e.target.hasAttribute("data-close")) closeModal();
  });

  // コピー操作
  const copyBtn = modal.querySelector('[data-action="copy"]');
  const msg = modal.querySelector(".maillink-modal__msg");
  copyBtn.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(email);
      msg.textContent = "アドレスをコピーしました";
    } catch (err) {
      msg.textContent = "コピーできませんでした。手動でコピーしてください";
    }
  });

  return modal;
};

const openModal = (subject, body, trigger) => {
  if (!modal) createModal();
  lastFocused = trigger;
  modal.querySelector('[data-action="mail"]').href = buildMailto(subject, body);
  modal.querySelector('[data-action="gmail"]').href = buildGmailUrl(subject, body);
  modal.querySelector(".maillink-modal__msg").textContent = "";
  modal.hidden = false;
  document.body.classList.add("is-maillink-open");
  modal.querySelector(".maillink-modal__close").focus();
};

// ESC で閉じる
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && modal && !modal.hidden) closeModal();
});

// 全ての .email-link にトリガーを生成
const containers = document.querySelectorAll(".email-link");

containers.forEach((container) => {
  // data 属性で件名・本文を任意に差し込める
  const subject = container.dataset.subject || "";
  const body = container.dataset.body || "";

  const a = document.createElement("a");
  a.href = buildMailto(subject, body); // JS無効時のフォールバック
  a.textContent = email;
  container.appendChild(a);

  // .contact があればそこ全体を、無ければリンク自体をクリック範囲にする
  const trigger = container.closest(".contact") || a;
  trigger.classList.add("is-maillink-trigger");
  trigger.addEventListener("click", (e) => {
    e.preventDefault();
    openModal(subject, body, trigger);
  });
});
